import React from 'react'
import { useTranslation } from 'react-i18next'
import gql from 'graphql-tag'

import { useMutation } from 'components/graphql'
import { ServiceModal } from 'components/Modal'

const mutation = gql`
mutation reactivateCashRegister($id: ID!) {
  cashAssist {
    reactivateCashRegister(id: $id) {
      id
      name
      outOfOrder
      outOfOrderReason
      outOfOrderDate
    }
  }
}
`

const ReactivateCashRegister = ({ unmount, data }) => {
	const [t] = useTranslation()
	const [reactivateCashRegister] = useMutation(mutation)

	const handleReactivate = async () => {
		await reactivateCashRegister({
			variables: {
				id: data.id
			}
		})
		unmount()
	}

	return (
		<ServiceModal
			onClose={unmount}
			onOk={handleReactivate}
			width={340}
			label={t('options_section.strings.reactivateCashRegister')}
			text={t('options_section.strings.reactivateCashRegisterConfirm')}
		/>
	)
}

export default ReactivateCashRegister
